import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>
        <span style={{ color: "#c5ff05" }}>✔</span> Tickit Privacy Policy
      </h1>
      <h3>Developed by: Falcon Adi</h3>
      <p>
        Tickit respects your privacy. This Privacy Policy explains how Tickit
        handles your data.
      </p>
      <h4>What We Do</h4>
      <p>
        Tickit is a simple to-do list app that allows you to create and manage
        tasks on your device. We do not collect or store any of your information
        on our servers. All task information, including titles and done
        statuses, remains solely on your device.
      </p>
      <h4>Security</h4>
      Because your data is stored locally, the security of your information
      depends on your device's security practices. We recommend using strong
      passwords or passcodes to protect your device.
      <h4>Your Rights</h4>
      You have complete control over your data within Tickit. You can access, or
      delete your tasks at any time directly within the app.
      <h4>Changes to this Privacy Policy</h4>
      We may update this Privacy Policy from time to time. We will notify you of
      any changes by posting the new Privacy Policy on [link to where the policy
      is located within the app].
      <h4>Contact Us</h4>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        at adityapundir2k@gmail.com <br /> This Privacy Policy applies only to
        Tickit and does not cover any third-party applications or services that
        you may access through Tickit.
      </p>
    </div>
  );
}

export default App;
